import { computed } from 'vue'

import { useCurrentUser } from '@/shared/composables/current-user'

import { useFeatureAccessEmulatorStore } from './feature-access-emulator'

export const useWebSoftphoneEnabled = () => {
  const { currentUser } = useCurrentUser()
  const emulator = useFeatureAccessEmulatorStore()

  const webSoftphoneEnabled = computed(() =>
    emulator.resolveWebSoftphone(Boolean(currentUser.value?.webSoftphoneEnabled)),
  )

  const apiWebSoftphoneEnabled = computed(() =>
    Boolean(currentUser.value?.webSoftphoneEnabled),
  )

  return {
    webSoftphoneEnabled,
    apiWebSoftphoneEnabled,
  }
}
